/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HtmlContent } from '../../models/html-content';

export interface DownloadDocxApiV2SubmissionsDownloadDocxPost$Params {
      body: HtmlContent
}

export function downloadDocxApiV2SubmissionsDownloadDocxPost(http: HttpClient, rootUrl: string, params: DownloadDocxApiV2SubmissionsDownloadDocxPost$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, downloadDocxApiV2SubmissionsDownloadDocxPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

downloadDocxApiV2SubmissionsDownloadDocxPost.PATH = '/api/v2/submissions/download/docx';
